import { FunctionalComponent, h } from '@stencil/core';

export const CountdownDivider: FunctionalComponent = () => (
  <div class="countdown-component">
    <div class="countdown-medium">:</div>
    <div class="countdown-small">&nbsp;</div>
  </div>
);
